import { render, staticRenderFns } from "./SurveysTable.vue?vue&type=template&id=4d95c59e&"
import script from "./SurveysTable.vue?vue&type=script&lang=js&"
export * from "./SurveysTable.vue?vue&type=script&lang=js&"
import style0 from "./SurveysTable.vue?vue&type=style&index=0&id=4d95c59e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports